import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import HashIcon from "assets/icons/down.svg?react";
import { useEffect, useRef, useState } from "react";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { useOnClickOutside } from "usehooks-ts";

import { useTranslation } from "react-i18next";

const ChooseMethods: FC<Props> = ({
  onChoose,
  label,
  initOpen = false,
  onClose,
  className = "",
  types: typed,
}) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (active) {
      setActive(false);
    }

    if (onClose && !label) {
      onClose();
    }
  });

  useEffect(() => {
    if (!initOpen) return;
    setActive(true);
  }, [initOpen]);

  return (
    <div ref={outsideRef} className={`${styles.wrapper}`}>
      <div
        onClick={() => setActive(!active)}
        className={`${styles.card} ${className}`}
      >
        <HashIcon className={styles.icon} />
        <div className={styles.text}>{label ? label : t("packages.deliveryChannel")} </div>

        {!onClose && (
          <FontAwesomeIcon
            className={styles.closeIcon}
            icon={active ? faCaretUp : faCaretDown}
          />
        )}
      </div>

      {active && (
        <div className={styles.dropdown}>
          <div className={styles.list}>
            {typed.map((type) => (
              <div
                onClick={() => {
                  onChoose(type);
                  setActive(false);
                }}
                className={styles.box}
                key={type.id}
              >
                {<type.image />}
                {type.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChooseMethods;
